import {useSuspenseQueryWithDiagnostics} from "../utils/diagnostics";

function useDynamicImport<T>(name: string, imp: () => Promise<T>) {
  const res = useSuspenseQueryWithDiagnostics({queryKey: ["dynamicImport", name], queryFn: imp, staleTime: Infinity});
  return res.data;
}

export function useFriendlyMimes() {
  return useDynamicImport("friendly-mimes", async () => {
    // Destructure to allow dynamic tree shaking as per
    // https://github.com/rollup/rollup/pull/4952
    const {resolveMime} = await import("friendly-mimes");
    return {resolveMime};
  });
}

export function useXLSX() {
  return useDynamicImport("xlsx", async () => {
    const XLSX = await import("@sheet/core");
    return XLSX;
  });
}

export function useUuidByString() {
  return useDynamicImport("uuid-by-string", async () => {
    const {default: getUuid} = await import("uuid-by-string");
    return getUuid;
  });
}
